import React from 'react';
import { Layout } from '../components/Layout';
import { Zap } from 'lucide-react';
import natureImage from '../assets/aigc/images/nature-tech_1768402418_000.png';
import EnergyEfficiencyDatacenters from '../components/EnergyEfficiencyDatacenters.tsx';

export const About: React.FC = () => {
  return (
    <Layout>
      <div className="pt-20">
        <section id="about" className="py-24 bg-white overflow-hidden">
          <div className="container mx-auto px-6">
            <div className="flex flex-col lg:flex-row items-center gap-16">
              <div className="lg:w-1/2">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                  <img src={natureImage} alt="Nature and Technology" className="w-full" />
                  <div className="absolute inset-0 bg-gradient-to-tr from-blue-600/20 to-transparent mix-blend-overlay" />
                </div>
              </div>
              <div className="lg:w-1/2">

                <div className="flex items-center gap-2 text-emerald-600 font-semibold mb-4">
                  <Zap className="w-5 h-5" />
                  <span>Vihreän energian konesali - puhtaasti Suomessa</span>
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
                  Helsinki DC optimoi jäähdytystä AI:n avulla
                </h2>
                <p className="text-slate-600 text-lg mb-6 leading-relaxed">
<p/>Tekoälystä on nopeasti tulossa yksi tehokkaimmista työkaluista datakeskusten energiankulutuksen ja hiilijalanjäljen pienentämiseen. Uusimpien pilottihankkeiden mukaan tekoälyyn perustuva optimointi voi vähentää konesalin sähkönkulutusta ja päästöjä tyypillisesti 20–40 % riippuen kohteesta.
<p/>Asiantuntijoiden mukaan seuraavan 3–5 vuoden aikana juuri tekoälypohjainen optimointi tulee todennäköisesti olemaan se keino, jolla konesalit pääsevät suurimmalla osalla päästövähennystavoitteistaan ilman mittavia laiteinvestointeja.
<p/>Hiiliviisas datakeskus ei siis enää tulevaisuudessa ole pelkkä tehokas laitteisto – se on ennen kaikkea erittäin fiksu algoritmi.
Tekoälyä hyödynnetään erityisesti seuraavilla osa-alueilla:
                </p>
                <ul className="space-y-4">
                  {[
                    "Reaaliaikainen jäähdytyksen optimointi (usein suurin yksittäinen energiasyöppö)",
                    "Palvelimien kuormituksen älykäs ajoittaminen ja siirtäminen",
                    "Tyhjäkäynnin minimointi ja resurssien dynaaminen allokointi",
                    "Uusiutuvan energian saatavuuden ennustaminen ja hyödyntäminen"
                  ].map((item, i) => (
                    <li key={i} className="flex items-center gap-3 text-slate-700">
                      <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-600">
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};
